import { isPlainObject } from 'lodash'

// Used to updated a user's preferences on the react side of things.
// We should probably create a user reducer at some point and move
// this and most of window.data into it.

// Pass an object in with any relevant preferences e.g. { show_premium: true }
export const setUserPreference = async (preference) => {
  if(!preference || !isPlainObject(preference)) {
    debug('setUserPreference: Sorry, I need an object to set a user\'s preference')
    return
  }

  // Can only save for folks logged in
  if(!window.data.current_user_id) {
    return
  }

  try {
    const response = await fetch('/preferences.json', {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ data: preference })
    })

    const data = await response.json()

    if(data.status === 'ok') {
      debug(`setUserPreference: Successfully set user's preference: ${data.data}`)
      return true
    } else {
      debug(`setUserPreference: Server returned error: ${data.message || 'Unknown error'}`)
      return false
    }
  } catch (err) {
    debug(`setUserPreference: Failed to save user's preference: ${err}`)
    throw err
  }
}

// Pass a string of the key for the preference
export const getUsersPreference = async (key) => {

  if(!key) {
    debug('getUserPreference: Sorry, I need a key to fetch a user\'s preference')
    return
  }

 // Can only save for folks logged in
  if(!window.data.current_user_id) {
    return
  }

  const preferences = await fetch(`/preferences.json?key=${key}`)
  const response = await preferences.json()
  if(response.status === 'ok') {
    debug(`getUserPreference: Successfully got user's preference: key=${response.key}, value=${response.value}`)
    return response.value
  } else {
    debug('getUserPreference: Failed to get user\'s preference')
    return
  }
}
// Parcel Preferences start
const STORAGE_KEY = 'parcel_detail_preferences'

let inMemoryPreferences = null
const listeners = new Set()

function notifyAllSubscribers(next) {
  for(const listener of Array.from(listeners)) {
    try {
      listener(next)
    } catch (err) {
      console.error('parcelPrefs subscriber failed: ', err)
    }
  }
}

// Force boolean
function normalizeParcelPrefs(rawPrefs) {
  const parsed = rawPrefs?.value || rawPrefs || {}
  const normalized = { ...parsed }
  Object.keys(normalized).forEach(key => {
    if(normalized[key] === 'true') normalized[key] = true
    if(normalized[key] === 'false') normalized[key] = false
  })
  return normalized
}

// saves to tab
if(typeof window !== 'undefined') {
  window.addEventListener('storage', e => {
    if(e.key !== STORAGE_KEY) return
    try {
      inMemoryPreferences = e.newValue ? JSON.parse(e.newValue) : null
      notifyAllSubscribers(inMemoryPreferences)
    } catch (err) {
      console.warn('storage failed', err)
    }
  })
}

export function applyDefaults (userPrefs, defaults) {
  return { ...defaults, ...userPrefs }
}

export function getCachedParcelPrefs() {
  if(inMemoryPreferences !== null) return inMemoryPreferences
  try {
    const s = localStorage.getItem(STORAGE_KEY)
    if(s != null) {
      inMemoryPreferences = JSON.parse(s)
      return inMemoryPreferences
    }
  } catch (err) {
    console.warn('caching parcel prefs failed', err)
  }
  return null
}
// Parcel details thunk
export async function fetchAndCacheParcelPrefs(getUsersPreference) {
  const raw = await getUsersPreference('parcel_detail_preferences')
  const normalized = normalizeParcelPrefs(raw)
  inMemoryPreferences = normalized
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized))
  } catch (err) {
    console.warn('fetch and cache parcel prefs failed', err)
  }
  notifyAllSubscribers(inMemoryPreferences)
  return inMemoryPreferences
}

export function updateParcelPrefsCache(newPrefs) {
  const normalized = normalizeParcelPrefs(newPrefs)
  inMemoryPreferences = normalized
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized))
  } catch (err) {
    console.warn('update parcel prefs cache failed', err)
  }
  notifyAllSubscribers(inMemoryPreferences)
  return inMemoryPreferences
}

export function subscribeParcelPrefs(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}


